import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { VerseNodeView } from "@/components/editor/nodeviews/VerseNodeView";

export const VerseBlock = Node.create({
  name: "verseBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      lines: { default: [] },
      attribution: { default: "" },
      title: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="verse-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "verse-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(VerseNodeView);
  },
});
